import { render } from "./CorporateDataTable.vue?vue&type=template&id=7dce5ade&scoped=true"
import script from "./CorporateDataTable.vue?vue&type=script&lang=js"
export * from "./CorporateDataTable.vue?vue&type=script&lang=js"

import "./CorporateDataTable.vue?vue&type=style&index=0&id=7dce5ade&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dce5ade"]])

export default __exports__